import { type ChangeHandler,type FieldError,type FieldErrors } from "react-hook-form"
import { FloatingInputGroupElemBootStrap } from "./FloatingInputBootstrap";
import { useState } from "react";
import { useTrads } from "../../contexts/trads/useTrads";
import { getByPath } from "../../tools/utils";
interface RegisterOutput {
    onChange:ChangeHandler,
    onBlur: ChangeHandler,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref:	React.Ref<any>,
    name:	string
}
interface Props {
    name:string,
    label:string,
    registerOutput:RegisterOutput,
    registerOutputValidation:RegisterOutput,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errors:FieldErrors<any>,
    rest?:Record<string,string|boolean|number>,
    restValidation?:Record<string,string|boolean|number>,


}
function PasswordSetter({name,label,registerOutput,registerOutputValidation,errors,rest,restValidation}:Props) {
    const [visible,setVisible]=useState(false);
    const {translate}=useTrads();
    const errorsF1=getByPath(errors,name) as FieldError[];
    const errorsF2=getByPath(errors,name+'_verif') as FieldError[];

    return (
        <div className="input-group">
            
                <FloatingInputGroupElemBootStrap
                name={name}
                label={label}
                type={(visible)?"text":"password"}
                errors={errors}
                registerOutput= {registerOutput}
                rest={rest}
                ></FloatingInputGroupElemBootStrap>

                <FloatingInputGroupElemBootStrap
                name={name + "_verif"}
                label={translate('password_field_confirm')}
                type={(visible)?"text":"password"}
                errors={errors}
                registerOutput= {registerOutputValidation}
                rest={restValidation}
                ></FloatingInputGroupElemBootStrap>


                

 

             <div className="input-group-append">
                <span className="input-group-text h-100">
                    <a onClick={()=>{ setVisible(!visible); }}>
                        <i className={(visible)?"bi bi-eye-slash":"bibi bi-eye"}></i>
                        <span className="visually-hidden">{translate('password_field_show')}</span>
                    </a>
                </span>
            </div>
            {(errorsF1.length || errorsF2.length) ?
                <div className="invalid-feedback">
                    {errorsF1.map((error) => {
                        return  <p key={error.message}>{translate(error.message)}</p>
                    })}
                    
                </div>
            :null}
        </div>

    );
}
export default PasswordSetter;